<template>
    <transition name="slide-right-transition">
        <div v-if="isActive" class="snackbar" role="alert"
             :class="[colorString ? 'snackbar-' + colorString : '', {'pb-8': showCloseButton}]">
            <span v-if="title" class="snackbar__title">{{ title }}</span>
            <span v-if="message" class="snackbar__message" v-html="message"/>
            <slot/>
            <div v-if="showCloseButton" class="flex align-center justify-end">
                <btn @click="isActive = false" color="white" text>{{ closeText }}</btn>
            </div>
        </div>
    </transition>
</template>

<script>
import AutoToggleable from "../../mixins/AutoToggleable";
    import Colorable from "../../mixins/Colorable";

    export default {
        name: "Snackbar",
        mixins: [AutoToggleable, Colorable],

		emits: ['show', 'hide'],

        props: {
            title: {
                type: String,
                default: null
            },

            message: {
                type: String,
                default: null
            },

            // Whether to show the close button if message and title is specified
            closeable: {
                type: Boolean,
                default: true
            }
        },

        computed: {
            closeText() {
                return this.$t('action.close')
            },

            showCloseButton() {
                return this.title && this.message && this.closeable !== false
            }
        },

        watch: {
            isActive(active) {
                if (active) {
                    this.$emit('show');
                } else {
                    this.$emit('hide');
                }
            }
        }
    }
</script>

<style>
/*********************
  Inputs
**********************/
/*********************
  Typography
**********************/
/*********************
  Inputs
**********************/
/*********************
  Shadows
**********************/
/*********************
  Layout
**********************/
/*********************
  Card
**********************/
/*********************
  Opacity
**********************/
.app .snackbar {
  position: fixed;
  display: flex;
  flex-direction: column;
  background-color: #008200;
  color: #ffffff;
  padding: 16px;
  border-radius: 4px;
  z-index: 1002;
  top: 56px;
  right: 0;
  margin: 10px;
  height: auto;
  letter-spacing: 0.15px;
  min-height: 16px;
  min-width: 112px;
  max-width: 100%;
  box-sizing: content-box;
  font-size: 14px;
  pointer-events: auto;
  transition: inherit;
  transition-property: opacity, transform;
  box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12);
}
@media (min-width: 640px) {
  .app .snackbar {
    max-width: 400px;
    min-width: 224px;
  }
}
.app .snackbar .snackbar__title {
  margin-bottom: 10px;
  font-weight: 600;
}
.app .snackbar.snackbar-white {
  color: #ffffff;
  background-color: #ffffff;
}
.app .snackbar.snackbar-black {
  color: #ffffff;
  background-color: #2e3535;
}
.app .snackbar.snackbar-primary {
  color: #ffffff;
  background-color: #008200;
}
.app .snackbar.snackbar-secondary {
  color: #ffffff;
  background-color: #f0820a;
}
.app .snackbar.snackbar-error {
  color: #ffffff;
  background-color: #FA5555;
}
.app .snackbar.snackbar-success {
  color: #ffffff;
  background-color: #47a447;
}
.app .snackbar.snackbar-warning {
  color: #ffffff;
  background-color: #EB9E05;
}
.app .snackbar.snackbar-transparent {
  color: #ffffff;
  background-color: transparent;
}
</style>